import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-user-layout',
    template: '<router-outlet></router-outlet>',
    encapsulation: ViewEncapsulation.None
})
export class UserLayoutComponent {

}
